import styled from "styled-components";

export const Wrapper = styled.div`
  width:50%;
  margin-bottom:1.25rem;

  h4 {
    font-family: Roboto;
    font-size: 14px;
    font-weight: bold;
    padding-left: 0.75rem;    
    color:#5e6d73;
  }

  ul {
    padding: 0;
    margin-bottom:0;
    
    li {
      list-style-type: none;
      padding: 0 0.75rem;
      color: #5e6d73;
      font-family: Roboto;
      font-size: 14px;
    }

    li:nth-child(odd) {
      background-color: #fafafa;      
    }

  }

  &.complete {
    h4 {
      color: #20907c;
    }
    li {
      .icon {
        color: #20907c;
      }
    }
  }

  &.incomplete {
    h4 {
      color: #eb5f65;
    }
    li {
      .icon {
        color: #eb5f65;
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/Debriefs/components/DebriefDashboard/components/UnitList/style.js